import { render, staticRenderFns } from "./PhoneItem.vue?vue&type=template&id=fcaef0fc&"
import script from "./PhoneItem.vue?vue&type=script&lang=js&"
export * from "./PhoneItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports